import React from 'react';
import { useApp } from './AppContext';
import { Button } from './Components';
import { HealthAssistant } from './HealthAssistant';
import { AdminDashboard } from './AdminDashboard';
import { DoctorDashboard } from './DoctorDashboard';
import { PatientDashboard as PatientView } from './PatientDashboard';

export const Dashboard: React.FC<{ setPage: (p: string) => void, onStartConsultation: (id: string) => void }> = ({ setPage, onStartConsultation }) => {
    const { user, switchUserRoleDemo } = useApp();

    if (!user) return (
        <div className="flex flex-col items-center justify-center py-40 px-6 text-center">
            <h2 className="text-3xl md:text-4xl font-black text-slate-900 mb-6 tracking-tight">Access Restricted</h2>
            <p className="text-slate-400 font-medium mb-10 max-w-md">You must be logged in to access the clinical portal.</p>
            <Button onClick={() => setPage('login')}>Sign In to Continue</Button>
        </div>
    );

    return (
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-8 md:py-16 animate-in fade-in duration-700 relative">
            <HealthAssistant />
            
            <div className="mb-8 md:mb-12 flex flex-col md:flex-row md:items-end justify-between gap-6 pb-6 border-b border-slate-100">
                <div>
                    <div className="flex items-center gap-2 mb-2">
                        <span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse"></span>
                        <p className="text-[9px] md:text-[10px] font-black uppercase text-indigo-600 tracking-[0.4em]">
                            {user.role === 'admin' ? 'System Administrator' : user.role === 'doctor' ? 'Licensed Medical Practitioner' : 'Verified Patient Portal'}
                        </p>
                    </div>
                    <h1 className="text-3xl md:text-5xl font-black text-slate-900 tracking-tight leading-tight">
                        {user.role === 'admin' ? 'Administrative Core' : user.role === 'doctor' ? `Practitioner Portal` : `Personal Health Portal`}
                    </h1>
                </div>

                {/* Portal View Switcher (Restricted strictly to authenticated Administrators) */}
                {user.role === 'admin' && (
                <div className="flex items-center gap-1.5 p-1.5 bg-slate-100/90 rounded-2xl border border-slate-200/80 shadow-xs self-start md:self-auto">
                    <span className="text-[10px] font-black uppercase tracking-wider text-slate-400 px-2.5 hidden sm:inline">
                        Admin Preview:
                    </span>
                    <button
                        type="button"
                        onClick={() => switchUserRoleDemo('admin')}
                        className="px-3 py-1.5 rounded-xl text-xs font-black transition-all flex items-center gap-1.5 bg-purple-600 text-white shadow-sm shadow-purple-500/30"
                    >
                        <i className="fa-solid fa-shield-halved text-[11px]"></i>
                        Admin Core
                    </button>
                </div>
                )}
            </div>

            {user.role === 'admin' && <AdminDashboard setPage={setPage} />}
            {user.role === 'doctor' && <DoctorDashboard onStartConsultation={onStartConsultation} />}
            {user.role === 'patient' && <PatientView onStartConsultation={onStartConsultation} setPage={setPage} />}
            {user.role === 'guest' && <PatientView onStartConsultation={onStartConsultation} setPage={setPage} />}
        </div>
    );
};